module.exports = "/_next/static/images/PredictiveAI-929fd8b7705206b3a2d7f68c6db838ae.webp";